import {
  getFallbackImageUrl,
  getImageSrcSets,
  getHeightConstrainedToAspectRatio,
} from "../../util/imageUtil";

import { ImageProps } from "./types";

import styles from "./styles.module.css";

export const Picture = (props: ImageProps) => {
  const {
    alt = "",
    assetUrl,
    tabletBreakpoint = 759,
    desktopMaxWidth = 1200,
    mobileMaxWidth = 600,
    aspectRatio,
    style = {},
    isLazy = false,
  } = props;

  const { mobile, desktop } = getImageSrcSets({
    assetUrl,
    desktopMaxWidth,
    mobileMaxWidth,
    aspectRatio,
  });

  const mobileMinHeight = getHeightConstrainedToAspectRatio({
    width: mobileMaxWidth,
    aspectRatio,
  });

  return (
    <picture className={styles.imageContainer}>
      <source
        media={`screen and (max-width: ${tabletBreakpoint}px)`}
        srcSet={mobile}
      />
      <source
        media={`screen and (min-width: ${tabletBreakpoint}px)`}
        srcSet={desktop}
      />
      <img
        className={styles.image}
        style={style}
        src={getFallbackImageUrl(assetUrl, mobileMaxWidth, mobileMinHeight)}
        loading={isLazy ? "lazy" : "eager"}
        alt={alt}
      />
    </picture>
  );
};

Picture.displayName = "Image.Picture";

export const Link = (props: ImageProps) => (
  <a className={styles.linkedImage} href={props.linkToUrl}>
    <Picture {...props} />
  </a>
);

Link.displayName = "Image.Link";

export const Component = (props: ImageProps) => {
  if (!props.assetUrl) return null;

  return props.linkToUrl ? <Link {...props} /> : <Picture {...props} />;
};

Component.displayName = "Image.Component";
